import React from 'react';
import { Button } from './ui/Button';
import { Container } from './ui/Container';
import { CheckCircle } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center bg-nav overflow-hidden" data-id="element-151">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat transform scale-105" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/aJpq2QmtoAqrwouJim2RWn/625075457_1464988238968623_5999708067650713080_n.jpg')"
    }} data-id="element-152">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40" data-id="element-153"></div>
      </div>

      {/* Content */}
      <Container className="relative z-10 px-4" data-id="element-154">
        <div className="max-w-3xl" data-id="element-155">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight drop-shadow-lg font-heading uppercase tracking-tight" data-id="element-156">
            Build Confidence.
            <br data-id="element-157" />
            Discipline.
            <br data-id="element-158" />
            <span className="text-accent" data-id="element-159">Strength.</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-200 mb-10 font-light max-w-2xl leading-relaxed" data-id="element-160">
            Taekwondo classes for children, families, and adults in Round Lake,
            Illinois — building focus, fitness, and confidence on the mat.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-161">
            <a href="#signup" className="w-full sm:w-auto" data-id="element-162">
              <Button variant="primary" size="lg" fullWidth className="text-lg py-4 shadow-xl shadow-red-900/30" data-id="element-163">
                Get One Week Free Trial
              </Button>
            </a>
            <a href="tel:8472128045" className="w-full sm:w-auto" data-id="element-164">
              <Button variant="secondary" size="lg" fullWidth className="text-lg py-4" data-id="element-165">
                Call (847) 212-8045
              </Button>
            </a>
          </div>

          {/* Trust Chips */}
          <div className="flex flex-wrap gap-4 md:gap-8 border-t border-white/20 pt-8" data-id="element-166">
            <TrustChip text="Kukkiwon Affiliated" data-id="element-167" />
            <TrustChip text="WTF / USNTF / ITSO" data-id="element-168" />
            <TrustChip text="All ages & skill levels" data-id="element-169" />
          </div>
        </div>
      </Container>
    </section>;
}
function TrustChip({
  text
}: {
  text: string;
}) {
  return <div className="flex items-center text-white/90 font-medium text-sm md:text-base" data-id="element-170">
      <CheckCircle className="w-5 h-5 text-accent mr-2 flex-shrink-0" data-id="element-171" />
      {text}
    </div>;
}